import * as React from 'react';
import { Input } from '../input/input';
import { InputProps } from '@/interfaces';
import { validationOnlyNumber } from '@/lib';

export const InputZipCode: React.FC<
	InputProps & React.InputHTMLAttributes<HTMLInputElement>
> = ({ name, setValueInput, rules, ...props }) => {
	const [isDelete, setIsDelete] = React.useState(false);

	const onKeyDownHandler = (event: any) => {
		validationOnlyNumber(event);
		const codigo = event.which || event.keyCode;
		if (codigo === 8) {
			setIsDelete(true);
		} else {
			setIsDelete(false);
		}
	};

	const handleChange = (e: React.ChangeEvent<any>) => {
		const val = e.target.value;

		const cadena = val.replaceAll('-', '');

		let newFormat = false;
		let nextValue = val;

		if (!isDelete) {
			if (!isNaN(Number(cadena))) {
				if (cadena.length === 6) {
					newFormat = true;
					nextValue = cadena.replace(/([0-9]{5})/g, '$1-');
				} else if (cadena.length === 10) {
					newFormat = true;
					nextValue = cadena.replace(/([0-9]{5})([0-9]{4})/g, '$1-$2');
				}
			}
		}

		setValueInput && setValueInput(name, newFormat ? nextValue : val);
		setIsDelete(false);
	};

	const finalRules = React.useMemo(() => {
		return {
			...rules,
			pattern: {
				value: /^(?!0+$)\d{5}(-\d{4})?$/,
				message: 'Please enter a valid Zip Code',
			},
			minLength: {
				value: 5,
				message: 'Please enter a valid Zip Code',
			},
		};
	}, [rules]);

	return (
		<>
			<Input
				name={name}
				type="text"
				onChangeCustom={handleChange}
				onKeyDown={onKeyDownHandler}
				maxLength={10}
				rules={finalRules}
				{...props}
			></Input>
		</>
	);
};
